/*** IMPORTS FROM imports-loader ***/
var define = false;

import Vue from 'vue';
import HeaderVue from './components/header/Header';

export default class Header {

    constructor(mainContainer) {
        this.mainContainer = mainContainer;
    }

    /**
     * @returns {boolean}
     * @private
     */
    _isExist() {
        return $(this.mainContainer).length !== 0;
    }

    _HeaderVue() {

        let headerApp = new Vue({
            el: this.mainContainer,
            components: {
               headerVue: HeaderVue
            },
        });
    }

    init() {

        if (!this._isExist()) return;

        this._HeaderVue();
    }
}



// WEBPACK FOOTER //
// ./app/Sites/AT/assets/js/vue/Header.js